import { Checkbox, Colors, Icon } from '@blueprintjs/core'
import * as React from 'react'
import { CategoryRowIconStyle, CategoryRowStyle, CategoryRowStyleHighlighted, TerminalCategoryRowStyle } from './styles'
import { CategoryMultiselectCategory } from './types'

export interface CategoryRowProps {
  category: CategoryMultiselectCategory
  checked: boolean
  highlighted: boolean
  hasChildren?: boolean

  onHighlight?: (highlightedPath: number[]) => void
  onCheck: (category: CategoryMultiselectCategory) => void
}

export class CategoryRow extends React.Component<CategoryRowProps, {}> {
  highlightPath = (): number[] => {
    const { category } = this.props
    const ancestry = category.ancestry ? category.ancestry.split('/').map(id => parseInt(id)) : []
    return [...ancestry, category.id]
  }

  onCheck = (e: React.SyntheticEvent): void => {
    e.stopPropagation()
    this.props.onCheck(this.props.category)
  }

  onNavigate = (e: React.MouseEvent): void => {
    e.stopPropagation()
    const { onHighlight, hasChildren } = this.props
    if (hasChildren && onHighlight) {
      onHighlight(this.highlightPath())
    }
  }

  onRowClick = (e: React.MouseEvent): void => {
    if (e.target === e.currentTarget) {
      this.onNavigate(e)
    }
  }

  render() {
    const { category, checked, hasChildren, highlighted } = this.props
    let style = highlighted ? CategoryRowStyleHighlighted : CategoryRowStyle
    if (!hasChildren) style = TerminalCategoryRowStyle

    return (
      <div
        className="category-multiselect-row"
        style={style}
        data-testid={`category-multiselect-row-${category.id}`}
        onClick={hasChildren ? this.onRowClick : undefined}
      >
        <Checkbox
          onChange={this.onCheck}
          checked={checked}
          style={{ margin: 0 }}
          tabIndex={-1}
          onClick={e => e.stopPropagation()}
        />
        <span style={{ cursor: 'pointer', userSelect: 'none', marginLeft: 4 }} onClick={this.onCheck}>
          {category.name}
        </span>
        {hasChildren && (
          <div
            style={CategoryRowIconStyle}
            onClick={this.onNavigate}
            role="button"
            aria-label={`Expand ${category.name}`}
            tabIndex={0}
          >
            <Icon icon="chevron-right" color={Colors.GRAY3} />
          </div>
        )}
      </div>
    )
  }
}

export default CategoryRow
